module.exports = __webpack_public_path__ + "static/img/irole.d8bdcba.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/lxx/irole.png
// module id = ygcs
// module chunks = 7